import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['image', 'canvas']
  static values = { anomalies: Array }

  connect () {
    if (this.imageTarget.complete && this.imageTarget.naturalWidth > 0) {
      this.draw()
    }
    this.boundResize = () => this.draw()
    window.addEventListener('resize', this.boundResize)
  }

  disconnect () {
    if (this.boundResize) {
      window.removeEventListener('resize', this.boundResize)
    }
  }

  draw () {
    const image = this.imageTarget
    const canvas = this.canvasTarget
    const naturalWidth = image.naturalWidth
    const naturalHeight = image.naturalHeight
    if (!naturalWidth || !naturalHeight) return

    canvas.width = naturalWidth
    canvas.height = naturalHeight
    const ctx = canvas.getContext('2d')
    ctx.clearRect(0, 0, naturalWidth, naturalHeight)

    const lineWidth = Math.max(2, Math.round(naturalWidth / 400))
    const fontSize = Math.max(14, Math.round(naturalWidth / 60))

    this.anomaliesValue.forEach((anomaly) => {
      this._drawAnomaly(ctx, anomaly, naturalWidth, naturalHeight, lineWidth, fontSize)
    })
  }

  _drawAnomaly (ctx, anomaly, imageWidth, imageHeight, lineWidth, fontSize) {
    const polygon = anomaly.polygon || []
    if (polygon.length === 0) return

    const scaleX = anomaly.media_width ? imageWidth / anomaly.media_width : 1
    const scaleY = anomaly.media_height ? imageHeight / anomaly.media_height : 1

    ctx.strokeStyle = '#ff3b30'
    ctx.fillStyle = 'rgba(255, 59, 48, 0.15)'
    ctx.lineWidth = lineWidth
    ctx.beginPath()
    polygon.forEach((point, index) => {
      const x = point.x * scaleX
      const y = point.y * scaleY
      if (index === 0) ctx.moveTo(x, y)
      else ctx.lineTo(x, y)
    })
    ctx.closePath()
    ctx.fill()
    ctx.stroke()

    const label = `${anomaly.type} (${anomaly.confidence}%)`
    const anchor = polygon.reduce(
      (acc, point) => (point.y * scaleY < acc.y ? { x: point.x * scaleX, y: point.y * scaleY } : acc),
      { x: polygon[0].x * scaleX, y: polygon[0].y * scaleY }
    )

    ctx.font = `${fontSize}px sans-serif`
    const padding = Math.round(fontSize * 0.4)
    const textWidth = ctx.measureText(label).width
    const labelHeight = fontSize + padding * 2
    let labelX = anchor.x
    let labelY = anchor.y - labelHeight - padding
    if (labelY < 0) labelY = anchor.y + padding
    if (labelX + textWidth + padding * 2 > imageWidth) labelX = imageWidth - textWidth - padding * 2

    ctx.fillStyle = '#ff3b30'
    ctx.fillRect(labelX, labelY, textWidth + padding * 2, labelHeight)
    ctx.fillStyle = '#ffffff'
    ctx.textBaseline = 'top'
    ctx.fillText(label, labelX + padding, labelY + padding)
  }
}
